module.exports = __webpack_public_path__ + "img/bmw.013ee500.jpeg";